import React from 'react';
import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';
import List, {
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,    
} from 'material-ui/List';
import Badge from 'material-ui/Badge';
import IconButton from 'material-ui/IconButton';
import FavoriteBorder from 'material-ui-icons/FavoriteBorder';
import TrendingUp from 'material-ui-icons/TrendingUp';
import SwapVert from 'material-ui-icons/SwapVert';
import Poll from 'material-ui-icons/Poll';
import AirlineSeatIndividualSuite from 'material-ui-icons/AirlineSeatIndividualSuite';
import Avatar from 'material-ui/Avatar';
import { Link, Redirect } from 'react-router-dom'
import isLoggedIn from '../helpers/isLoggedIn';
import store from 'store';

class Dashboard extends React.Component {

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    render() {

        if (!isLoggedIn()) {
            return <Redirect to="/login" />;
        }

        return (
            <div className="main-container">
                <div className="greetings-box">
                    <h3>Hello {store.get('username')},Welcome to the Helo World </h3>
                </div>

                <Grid container spacing={24}>
                    <Grid item xs={12}>
                        <Paper className="box helo-lx-data">
                            <div className={"colored-header small"}>
                                <h2>Your HELO LX Data</h2>
                            </div>
                            <div className="btn-wrapper">
                                <Link to='/HeartRate'>
                                    <IconButton>
                                        <Badge className="lx-badge" badgeContent={4} color="primary">
                                            <FavoriteBorder />
                                        </Badge>
                                    </IconButton>
                                </Link>
                                <p>Heart Rate</p>
                            </div>
                            <div className="btn-wrapper">
                                <Link to='/pressures'>
                                    <IconButton>
                                        <Badge className="lx-badge" badgeContent={4} color="primary">
                                            <TrendingUp />
                                        </Badge>
                                    </IconButton>
                                </Link>
                                <p>Blood pressure</p>
                            </div>
                            <div className="btn-wrapper">
                                <IconButton>
                                    <Badge className="lx-badge" badgeContent={4} color="primary">
                                        <SwapVert />
                                    </Badge>
                                </IconButton>
                                <p>Breath Rate</p>
                            </div>
                            <div className="btn-wrapper">
                                <IconButton>
                                    <Badge className="lx-badge" badgeContent={4} color="primary">
                                        <AirlineSeatIndividualSuite />
                                    </Badge>
                                </IconButton>
                                <p>Sleep</p>
                            </div>
                            <div className="btn-wrapper">
                                <IconButton>
                                    <Badge className="lx-badge" badgeContent={4} color="primary">
                                        <Poll />
                                    </Badge>
                                </IconButton>
                                <p>ECG</p>
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
                <Grid container spacing={24}>
                    <Grid item xs={12}>
                        <Paper className="box relations">
                            <div className={"colored-header small"}>
                                <h2>We Care</h2>
                            </div>
                            <Badge className="lx-badge" badgeContent={4} color="primary">
                                <Avatar src={require("../images/relation1.jpg")}></Avatar>
                            </Badge>
                            <Badge className="lx-badge" badgeContent={4} color="primary">
                                <Avatar src={require("../images/relation2.jpg")}></Avatar>
                            </Badge>
                            <Badge className="lx-badge" badgeContent={4} color="primary">
                                <Avatar src={require("../images/relation3.jpg")}></Avatar>
                            </Badge>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        )
    };
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/Dashboard.js